import { FC } from 'react';
import type { TradedTileData } from 'state/quotes/dashboard/model';

import { Price, PricingDate, ResultPanel, SolveModeLabel, StatusPanel, TileLayout } from './components';
import { StatusMessage } from './components/result/status';
import type { TileContentProps } from './Tile.common';

export const TradedTile: FC<TileContentProps<TradedTileData>> = ({ data, header, subHeader, footer }) => {
  return (
    <TileLayout header={header} subHeader={subHeader} footer={footer}>
      <ResultPanel
        color="info"
        solveModeLabel={<SolveModeLabel value={data.solveMode} size="small" />}
        price={
          <Price
            solveResult={data.solveResult}
            solveResultFormat={data.solveResultFormat}
            xMargin={data.xMargin}
            color="info"
          />
        }
        statusPanel={
          <StatusPanel className="alert-info">
            <StatusMessage msgKey="dashboard.traded" icon="check_circle" />
          </StatusPanel>
        }
        subHeader={<PricingDate when={data.lastUpdated} />}
      />
    </TileLayout>
  );
};

TradedTile.displayName = 'TradedTile';
